<template>
  <div class="wrapper">
    <template v-for="(selector, index) in selectors">
      <SelectorTypeShow
        :key="index"
        :selector="selector"
      />
    </template>
    <SelectorAdd :reference="reference" />
  </div>
</template>

<script>
export default {
  name: 'SelectorComposite',
  props: {
    reference: {
      required: true,
      type: String,
    },
    selectors: {
      required: true,
      type: Array,
    },
  },
}
</script>
